import React from "react";
import { Switch } from "react-router-dom";
import { SYSTEM_LOG_MASTER_ROUTE } from "config/route-consts";
import { ProtectedRoute, useCheckAuthorized } from "config/protected-route";

import SystemLogMaster from "./SystemLogMaster/SystemLogMaster";

function SystemLogView() {
  const { auth } = useCheckAuthorized();
  return (
    <Switch>
      <ProtectedRoute
        path={SYSTEM_LOG_MASTER_ROUTE}
        key={SYSTEM_LOG_MASTER_ROUTE}
        component={SystemLogMaster}
        auth={auth(SYSTEM_LOG_MASTER_ROUTE)}
      />
    </Switch>
  );
}

export { SystemLogMaster };
export default SystemLogView;
